module.exports = __webpack_public_path__ + "static/img/tyy.1db0feb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tyy.jpg
// module id = xKBr
// module chunks = 1